import TransactionAmountLabel from "./TransactionAmountLabel";

export default TransactionAmountLabel;
